import { Injectable, Injector } from '@angular/core';
import { Query, QueryHandler } from '@skylab-shared/core';
import { Constructor, Tuple } from '@skylab-shared/types';

export const QueryBusHandlers: Tuple<Function, Constructor<QueryHandler<Query<any>, any>>>[] = [];

@Injectable({ providedIn: 'root' })
export class QueryBus {

    public constructor(private injector: Injector) { }

    public queryAsync<TQuery extends Query<any>>(query: TQuery, params?: any): Promise<TQuery extends Query<infer TResult> ? TResult : unknown> {
        const [_, handler] = QueryBusHandlers.find(([type]) => query instanceof type)!;
        if (!handler)
            throw new Error(`Query handler for "${query.constructor.name}" does not exist.`);
        return this.injector.get(handler).handleAsync(query, params);
    }
}
